module.exports = __webpack_public_path__ + "bcaeb99f7bd058671938f5c1a201e5f9.woff";